module.exports = __webpack_public_path__ + "images/af1e307d07efb872e89c6bbe017c3239-staticmap.png";